import XmlAnnotationViewer from "./XmlAnnotationViewer";

export default function App() {
  return <XmlAnnotationViewer />;
}
